import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="product-search"
export default class extends Controller {
  static targets = ["input"]
  static values = {
    productsPath: String,
    delay: { type: Number, default: 500 }
  }

  connect() {
    this.timeoutId = null
  }

  disconnect() {
    this.clearPending()
  }

  submit(event) {
    event?.preventDefault()
    this.clearPending()
    this.visitWithQuery()
  }

  debounceSubmit(event) {
    event?.preventDefault()
    this.clearPending()
    this.timeoutId = window.setTimeout(() => this.visitWithQuery(), this.delayValue)
  }

  visitWithQuery() {
    if (!this.hasInputTarget) return

    const query = this.inputTarget.value.trim()
    const destination = this.buildDestinationURL(query)

    if (Turbo?.visit) {
      Turbo.visit(destination, { action: "replace" })
    } else {
      window.location.href = destination
    }
  }

  buildDestinationURL(query) {
    const base = this.productsPathValue || "/products"
    const url = new URL(base, window.location.origin)

    if (query.length > 0) {
      url.searchParams.set("q", query)
    } else {
      url.searchParams.delete("q")
    }

    this.copyFilterParams(url)
    return url.toString()
  }

  copyFilterParams(url) {
    const currentParams = new URLSearchParams(window.location.search)

    currentParams.forEach((value, key) => {
      if (key.startsWith("filters[")) {
        url.searchParams.append(key, value)
      }
    })
  }

  clearPending() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }
  }
}
